import { render, staticRenderFns } from "./DocumentEditSignView.vue?vue&type=template&id=5befa678&"
import script from "./DocumentEditSignView.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditSignView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditSignView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports